import Cookies from 'js-cookie'
import api from '@/services/api'
import router from '@/routes'

export default {
  namespaced: true,
  state: {
    user: null,
    card: null,
    token: null,
    links: null,
    payout: null,
    countries: null,
    transactions: null,
    isAuthenticated: false,
    errorMessage: null,
  },

  getters: {},

  mutations: {
    setUser(state, user) {
      state.user = user
    },

    setUserCard(state, card) {
      if (card.last4) {
        state.card = card
      }
    },

    setUserPayout(state, data) {
      state.payout = {
        account: data.payout.account,
        accountLink: data.payout.account_link,
        allowedCountries: data.payout.allowed_countries,
        type: data.payout.type,
        bank: data.payout.bank,
        country: data.payout.country,
        currency: data.payout.currency,
        name: data.payout.name,
        email: data.payout.email,
        status: data.payout.status,
        schedule: data.payout.schedule,
      }

      state.errorMessage = data.payout.error
    },

    setUserTransactions(state, transactions) {
      state.transactions = transactions
    },

    setAppLinks(state) {
      state.links = {
        appStore: process.env.VUE_APP_APPSTORE,
        playStore: process.env.VUE_APP_PLAYSTORE,
      }
    },

    clearUser(state) {
      state.user = null
      state.card = null
      state.transactions = null
      state.payout = null
    },

    setToken(state, token) {
      if (token) {
        Cookies.set('AUTH_TOKEN', token)
        state.token = token
        state.isAuthenticated = true
      }
    },

    setCountries(state, countries) {
      state.countries = []
      countries.forEach((country) => {
        state.countries.push({
          item: country.iso_3166_2,
          name: country.name,
        })
      })
    },

    clearToken(state) {
      Cookies.remove('AUTH_TOKEN')
      state.token = null
      state.isAuthenticated = false
    },

    handleError(state, error) {
      if (error && error.response && error.response.data) {
        state.errorMessage = error.response.data.message
      } else {
        state.errorMessage = error
      }
    },
  },

  actions: {
    init({ commit }) {
      const token = Cookies.getJSON('AUTH_TOKEN')
      commit('setToken', token)
      commit('setAppLinks', token)
    },

    async getAuthenticatedUser({ commit, state }) {
      await api
        .get('/auth/user')
        .then((res) => {
          commit('setUser', res.data.data.user)
        })
        .catch((err) => {
          if (err.response.status === 401) {
            commit('clearToken')
            commit('clearUser')
          }
        })
    },

    async getUserCard({ commit }) {
      await api
        .get('/payment/method')
        .then(({ data }) => {
          commit('setUserCard', data.data.card)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async getUserPayout({ commit }, country) {
      let condition = '?platform=web'

      if (country) {
        condition += `&country=${country}`
      }

      await api
        .get('/payout/account' + condition)
        .then(({ data }) => {
          commit('setUserPayout', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async attachCard({ commit }, params) {
      await api
        .post('/payment/method', params)
        .then(({ data }) => {
          commit('setUserCard', data.data.card)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async getUserTransactions({ commit }) {
      await api.get('/user/transactions').then(({ data }) => {
        commit('setUserTransactions', data.data.transactions)
      })
    },

    async getCountries({ commit }) {
      await api.post('/countries').then(({ data }) => {
        commit('setCountries', data.data.countries)
      })
    },

    async logout({ commit }) {
      // invalidate token
      await api.get('/auth/logout')

      // clear other states as deemed necessary
      commit('clearToken')
      commit('clearUser')

      router.replace({ name: 'auth.landing-page' })
    },
  },
}
